import React from 'react';
import PropTypes from 'prop-types';

import AccordionHead from 'base/ui_components/AccordionHead';

class MenuSectionHeader extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    isExpanded: PropTypes.bool,
    handleClick: PropTypes.func
  };

  render() {
    const { title, isExpanded, handleClick } = this.props;
    return (
      <AccordionHead
        title={title}
        isExpanded={isExpanded}
        handleClick={handleClick}
        dataTestId="menu-page-expand-icon"
      />
    );
  }
}

export default MenuSectionHeader;
